"use client";

import BreadCrumbs from "../BreadCrumbs/BreadCrumbs";
import { PricesFootnote } from "components/pages/prices/Footnote";
import { useCountryStateCookies } from "hooks/cookies/useCountryStateCookies";
import React from "react";
import type { CoinDetailType, CtaProps } from "types/prices";

export const PriceHeading = ({
  breadcrumbs,
  currentCoinDetail
}: {
  breadcrumbs: { cta: CtaProps[] };
  currentCoinDetail: CoinDetailType;
}) => {
  const { isUK } = useCountryStateCookies();

  return (
    <React.Fragment>
      {isUK && (
        <div className="mb-2">
          <PricesFootnote />
        </div>
      )}
      <BreadCrumbs breadcrumbs={breadcrumbs} />
      <h1 className="sr-only">{`${currentCoinDetail.name} (${currentCoinDetail.coin}) Price`}</h1>
    </React.Fragment>
  );
};
